import Cookies from "js-cookie";
const prefix = "weather_";
export const CookiesStorage = {
  getItem: (key: string) => {
    const value: any = Cookies.get(prefix + key);
    if (isEmptyType(value)) return "";
    if (isJSONString(value) && isEnableParse(value)) {
      return JSON.parse(value);
    }
    return value;
  },
  setItem: (key: string, value: any, duration = 8 * 60 * 60 * 1000) => {
    if (isEmptyType(value)) return;
    if (isObject(value)) {
      value = JSON.stringify(value);
    }
    const expires = new Date(Date.now() + duration);
    Cookies.set(prefix + key, value, { expires });
  },
  removeItem: (key: string) => {
    Cookies.remove(prefix + key);
  },
};
export const SessionStorage = {
  getItem: (key: string) => {
    const value: any = sessionStorage.getItem(prefix + key);
    if (isEmptyType(value)) return "";
    if (isJSONString(value) && isEnableParse(value)) {
      return JSON.parse(value);
    }
    return value;
  },
  setItem: (key: string, value: any) => {
    if (isEmptyType(value)) return;
    if (isObject(value)) {
      sessionStorage.setItem(prefix + key, JSON.stringify(value));
      return;
    }
    sessionStorage.setItem(prefix + key, value);
  },
  removeItem: (key: string) => {
    sessionStorage.removeItem(prefix + key);
  },
  clear(excludeKeys?: string[]) {
    if (isEmptyType(excludeKeys)) {
      sessionStorage.clear();
      return;
    }
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key && key.startsWith(prefix) && !excludeKeys?.includes(key.replace(prefix, ""))) {
        sessionStorage.removeItem(key);
      }
    }
  },
  key: (index: number) => {
    return sessionStorage.key(index);
  },
  length: sessionStorage.length,
};
export const LocalStorage = {
  getItem: (key: string) => {
    const value: any = localStorage.getItem(prefix + key);
    if (isEmptyType(value)) return "";
    if (isJSONString(value) && isEnableParse(value)) {
      return JSON.parse(value);
    }
    return value;
  },
  setItem: (key: string, value: any) => {
    if (isEmptyType(value)) return;
    if (isObject(value)) {
      localStorage.setItem(prefix + key, JSON.stringify(value));
      return;
    }
    localStorage.setItem(prefix + key, value);
  },
  removeItem: (key: string) => {
    localStorage.removeItem(prefix + key);
  },
  clear(excludeKeys?: string[]) {
    if (isEmptyType(excludeKeys)) {
      localStorage.clear();
      return;
    }
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(prefix) && !excludeKeys?.includes(key.replace(prefix, ""))) {
        localStorage.removeItem(key);
      }
    }
  },
  key: (index: number) => {
    return localStorage.key(index);
  },
  length: localStorage.length,
};
